'use strict';

import register from './core';
import '../functions/jquery-global.js';

register('checkbox', function(element) {
    var $checkbox = $(element).find('.button'),
        $input = $(element).find('input'),
        keyCode = Object.freeze({
            'SPACE': 32
        });
    $checkbox.on('keydown', function(e) {

        if (e.keyCode === keyCode.SPACE) {
            e.stopImmediatePropagation();
            e.preventDefault();
          $input.prop('checked', !$input.prop('checked')).trigger('change');
          $input.attr("aria-checked", $input.prop('checked'));
            $checkbox.focus();
        }
    });
});
